export const getGroupsLayoutStyles = () => ({
  controls: {
    display: 'flex',
    paddingBottom: 8,
  },

  channelControl: {
    marginLeft: 'auto',
  },

  groupContainer: {
    background: '#ffffff',
    borderRadius: 4,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

    '& .preview-string': {
      display: 'none',
    },

    '& .additional-disclaimer-message': {
      display: 'none',
    },

    '& .multi-line-processed-text': {
      wordBreak: 'break-word',
    },
  },

  inactiveGroup: {
    display: 'none',
  },
});

export const getCarouselOverrideStyles = () => ({
  carouselContainer: {
    '& .new-preview-carousel-container-adprelib ': {
      border: 'none',
    },

    '& .ad-preview-title': {
      fontSize: 14,
      margin: 0,
      padding: 20,
    },

    '& .exclude-aspect-ratio-button': {
      display: 'none',
    },

    '& .carousel-wrapper': {
      '& .carousel-inner': {
        paddingBottom: 24,
      },
      '& .carousel-control': {
        background: 'transparent',
      },
      '& .carousel-control.left': {
        left: 'calc(50% - 65px)',
        transform: 'translateX(-50%)',
        margin: '15px 0',
      },
      '& .carousel-control.right': {
        left: 'calc(50% + 60px)',
        transform: 'translateX(-50%)',
        margin: '15px 0',
      },
      '& .carousel-indicators': {
        display: 'flex',
        gap: '10px',
        left: '50% !important',
        transform: 'translateX(-50%)',
        margin: '20px 0 !important',

        '& li': {
          margin: '0',
        },
      },
    },
  },
});
